export default {
  apiUrl : 'https://haruka.misaki.miuna.net',
  url : 'hikari.misaki.miuna.net',
  movieUrl: 'https://files.miuna.net/files/test.mp4'
}